import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import withApi from '../../components/higherOrderComponents/withApi';
import { storeUser } from '../../store';

const configReader = require('../../config');

/**
 * Sign-in for the new tree.
 *
 * The flow is the old page's, unchanged: Google returns a credential, the API
 * exchanges it, the user goes into the store and the page reloads. That reload
 * looks crude and is — it is how the old admin gets the app to re-render after
 * login, and this is not the place to fix it.
 *
 * What is new is only the shell around it. The Google button itself renders
 * from the SDK and cannot be themed, which is why it sits on a white card in
 * both themes rather than fighting it.
 */
const LoginInternal = ({ api }) => {
  const { googleLoginClientId } = configReader.get();
  const [error, setError] = useState(null);

  return (
    <div className="next-login">
      <div className="next-login__card">
        <div className="next-login__brand">
          WannaSport
          <span className="next-header__badge">new</span>
        </div>

        <h1 className="next-login__title">Admin</h1>
        <p className="next-login__subtitle">
          Sign in with your WannaSport Google account.
        </p>

        {error && <div className="next-note next-note--error">{error}</div>}

        <div className="next-login__button">
          <GoogleOAuthProvider clientId={googleLoginClientId}>
            <GoogleLogin
              onSuccess={async ({ credential, clientId }) => {
                await api.profiles.loginGoogle(credential, clientId);
                const user = await api.profiles.getUser();
                storeUser(user);

                // Same as the old page: the app has no way to re-render itself
                // after the store changes, so it reloads.
                window.location.reload();
              }}
              onError={() => {
                // An `alert` here would be the last native dialog in the tree,
                // and a login screen has room to say it in place.
                setError('Google could not sign you in. Try again, or use the old admin.');
              }}
            />
          </GoogleOAuthProvider>
        </div>

        <a className="next-login__escape" href="/home">Go to the old admin</a>
      </div>
    </div>
  );
};

LoginInternal.propTypes = {
  api: PropTypes.object.isRequired
};

const Login = withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(LoginInternal));

Login.requiresLogin = false;

export default Login;
